import { generateMnemonic, keyPairFromMnemonic, keyPairFromPrivateKey} from "./src/seed-generator/seed_utils.js";

// Refer below lines of code for usage
// var mnemonic = generateMnemonic()
// var mnemonic = 'material tonight document logic purity balance topple excess unknown tell certain stamp'
// console.log('generateMnemonic', mnemonic)
// console.log(keyPairFromMnemonic('f', 0, mnemonic ))
// _publicKey: '04ec2a0a1384625f2174b24305a39166c20affd657e1d38192ed668d395f645589b885a75c9c36f3d81b8a3f1edc5407c1eaf4338e1175c3d8ea42aa411ffc7065',
//   _privateKey: '51c90f536efd6f267eb1cce4f40d5728734426d39320cfbbe40c31b728682032',
//   _address: 'f14qftvdn6xbc5hx5q52skupt37wmgzzedvsdh3gq'
// console.log(keyPairFromPrivateKey('f', '51c90f536efd6f267eb1cce4f40d5728734426d39320cfbbe40c31b728682032'))

export {generateMnemonic, keyPairFromMnemonic, keyPairFromPrivateKey};
